import { createEffect, onCleanup } from "solid-js";
import QRCode from "qrcode";

type Props = {
  token: string;
};

/** Door QR is the opaque registration token, never a ticketing barcode. */
export function MeetupQr(props: Props) {
  let canvas: HTMLCanvasElement | undefined;

  createEffect(() => {
    const token = props.token;
    const el = canvas;
    if (!el || !token) return;
    let cancelled = false;
    void QRCode.toCanvas(el, token, {
      width: 240,
      margin: 1,
      errorCorrectionLevel: "M",
      color: { dark: "#01050b", light: "#ffffff" },
    }).catch(() => {
      if (!cancelled) el.replaceChildren();
    });
    onCleanup(() => {
      cancelled = true;
    });
  });

  return (
    <canvas
      ref={(el) => {
        canvas = el;
      }}
      class="meetup-qr-canvas"
      width={240}
      height={240}
      aria-label="Meetup door QR"
    />
  );
}
